module.exports = __webpack_public_path__ + "static/img/3.578db17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncajzx/3.png
// module id = wsw1
// module chunks = 1